import { createAsyncThunk } from '@reduxjs/toolkit'
import { get, post } from '../services/crud'
import { ServiceConfig } from '../services/config'
import { ApiError, CardCapturedInput, PaymentMethod } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Payment`

// GET PAYMENTS BY LOCATION ID
export const getPayments = createAsyncThunk<
  PaymentMethod[],
  string,
  { rejectValue: ApiError }
>('payment/getPayments', async (locationId, thunkApi) => {
  const response = await get(`${baseUrl}/${locationId}`)

  if (response.ok) {
    const payload: PaymentMethod[] = await response.json()
    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

//========== C R E A T E ==========
export const sendPaymentNotification = createAsyncThunk<
  void,
  CardCapturedInput
>('payment/sendNotification', async (input, thunkApi) => {
  const response = await post(`${baseUrl}/cardCapturedNotification`, input)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
